import {
  TranslationManagerActions,
  TranslationManagerGetters,
  TranslationManagerMutations,
  TranslationManagerState
} from "@medapro-types/TranslationManager/translation-manager-store";
import { createNamespacedHelpers } from "vuex-composition-helpers";

const { useState, useActions, useGetters, useMutations } = createNamespacedHelpers<
  TranslationManagerState,
  TranslationManagerGetters,
  TranslationManagerActions,
  TranslationManagerMutations
>("translationManager");

export const useTranslationManagerState = () => {
  const state = useState([
    "runningPromises",
    "saveMessageSeen",
    "translationGroups",
    "translationProjects",
    "currentTranslationProject",
    "catalogs",
    "isLoading",
    "isSaving",
    "isOverviewLoading",
    "isCreatingProject",
    "overviewValues"
  ]);
  return state;
};

export const useTranslationManagerGetters = () => {
  const getters = useGetters(["hasUnsavedData", "isBusy", "lastRunSuccess", "isGroupLoading", "hasGroupUnsavedData"]);
  return getters;
};

export const useTranslationManagerMutations = () => {
  const mutations = useMutations([
    "add-running-promise",
    "notification-seen",
    "reset-running-promises",
    "set-translation-group-entries",
    "set-translation-detail-entries",
    "set-translation-groups",
    "set-translation-projects",
    "set-current-translation-project"
  ]);
  return mutations;
};

export const useTranslationManagerActions = () => {
  const actions = useActions([
    "loadTranslationProject",
    "loadTranslationProjects",
    "loadDetailEntries",
    "setTranslationGroupEntries",
    "saveAll",
    "saveTranslationGroup",
    "renameTranslationProject",
    "deleteTranslationProject",
    "loadAll",
    "loadCatalogs",
    "createTranslationProject",
    "applySearch",
    "translateEntriesWithDeepL",
    "translateSelectedEntriesWithDeepL",
    "exportTranslations",
    "importTranslations",
    "publishTranslationProject",
    "reloadOverviewValues"
  ]);
  return actions;
};
